import React, { FC } from "react";
import { Provider } from "react-redux";
import Store from "~/common/Store";
export default <Props extends Record<string, unknown>,>(Component: FC<Props>) => (props: Props) => <Provider store={Store}>
      <Component {...props} />
    </Provider>;